import type { CoursePlanItem, TeacherCohortAssignmentRecord } from "../auth/api-client";

/**
 * Translate a "gap" position in the plan rail (insert before this index) into the
 * `insertAfterPlanItemId` anchor the API expects: `null` for the start,
 * `undefined` for the end, or the preceding item's plan item id.
 */
export function insertAfterPlanItemIdForGap(
  items: readonly CoursePlanItem[],
  insertBeforeIndex: number
): string | null | undefined {
  if (insertBeforeIndex === 0) return null;
  if (insertBeforeIndex >= items.length) return undefined;
  return items[insertBeforeIndex - 1]?.planItemId;
}

export function assignmentIdAfterPlanItem(
  insertAfterPlanItemId: string | null | undefined,
  planItems: readonly CoursePlanItem[],
  assignments: readonly TeacherCohortAssignmentRecord[]
): string | null | undefined {
  if (insertAfterPlanItemId === undefined) return undefined;
  if (insertAfterPlanItemId === null) return null;
  const anchor = planItems.find((p) => p.planItemId === insertAfterPlanItemId);
  if (!anchor) return undefined;
  const assignment = assignments.find((a) => {
    if (anchor.itemKind === "lesson") {
      return a.itemKind !== "quiz" && a.itemKind !== "presentation" && a.lessonId === anchor.lesson.id;
    }
    if (anchor.itemKind === "quiz") {
      return a.itemKind === "quiz" && a.quizId === anchor.quiz.id;
    }
    return a.itemKind === "presentation" && a.presentationId === anchor.presentation.id;
  });
  return assignment?.id;
}

export function planItemIdAfterAssignment(
  insertAfterAssignmentId: string | null | undefined,
  planItems: readonly CoursePlanItem[],
  assignments: readonly TeacherCohortAssignmentRecord[]
): string | null | undefined {
  if (insertAfterAssignmentId === undefined) return undefined;
  if (insertAfterAssignmentId === null) return null;
  const assignment = assignments.find((a) => a.id === insertAfterAssignmentId);
  if (!assignment) return undefined;
  if (assignment.itemKind === "quiz" && assignment.quizId) {
    return planItems.find((p) => p.itemKind === "quiz" && p.quiz.id === assignment.quizId)?.planItemId;
  }
  if (assignment.itemKind === "presentation" && assignment.presentationId) {
    return planItems.find(
      (p) => p.itemKind === "presentation" && p.presentation.id === assignment.presentationId
    )?.planItemId;
  }
  if (assignment.lessonId) {
    return planItems.find((p) => p.itemKind === "lesson" && p.lesson.id === assignment.lessonId)?.planItemId;
  }
  return undefined;
}
